import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import route from '@/router'

// 创建一个axios实例
const service = axios.create({
  // baseURL: 'http://m.yundongshugenmatch.cn/api', // 向请求url前拼接
  // baseURL: 'https://yundongshugen.com/api', // 向请求url前拼接  原
  baseURL: 'https://web.yundongshugenmatch.cn/api', // 向请求url前拼接
  // withCredentials: true, // 当跨域请求时发送cookie
  timeout: 100000 // 	请求超时毫秒
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token')
    if (token) config.headers.Authorization = 'Bearer ' + token
    return config
  },
  error => {
    // 请求错误处理
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data // 直接使用响应数据
    if (res.code === 200) {
      return res // 返回整个响应数据
    } else if (res.code === 401 || res.code === 50012 || res.code === 50014) {
      // 重新登陆
      MessageBox.confirm('登录状态已过期，请再次登录', '确认注销', {
        confirmButtonText: '重新登陆',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.removeItem('userNmae')
        sessionStorage.removeItem('token')
        route.push('/login')
      })
      return Promise.reject(res) // 如果需要处理错误，可以返回一个 rejected promise
    } else {
      const err = new Error(res || '服务器开小差啦~')
      err.code = res.code
      err.message = res.msg
      return Promise.reject(err) // 返回错误
    }
  },
  error => {
    // 响应错误处理
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export const get = (url, params = {}, custom = {}) => service({ url, method: 'get', params, ...custom })
export const post = (url, data = {}, custom = {}) => service({ url, method: 'post', data, ...custom })
